import stbAPIGateway from '../../../../services/stbAPIGateway';

export const postCsvProductInstances = async (
  { rootGetters },
  { clientSid, productInstanceInfo }
) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const result = await stbApi.postHubCsvProductInstances(clientSid, productInstanceInfo);
  return result;
};
